export const TEST_STATES = {
  EDITING: 'editing',
  PUBLISHED: 'published',
  RUNNING: 'running',
  COMPLETE: 'complete',
  ERROR: 'error'
}

export const TEST_METHODS = {
  CUSTOM: 'custom-page',
  PAGE: 'single-page'
}
